import { Action } from '@ngrx/store';
import { IEventSponsorship } from 'src/commons';

export enum EventSponsorshipActionTypes {
  LoadEventSponsorshipState = '[EventSponsorship] Load EventSponsorship State',
  LoadEventSponsorshipStateSuccess = '[EventSponsorship] Load EventSponsorship State Success',
  LoadEventSponsorshipStateFail = '[EventSponsorship] Load EventSponsorship State Fail',
  LoadInitialState = '[EventSponsorship] Load EventSponsorship Initial State',
  EventSponsorshipScreenErrorReset = '[EventSponsorship] EventSponsorship Screen Error Reset'

}

export class LoadEventSponsorshipState implements Action {
  readonly type = EventSponsorshipActionTypes.LoadEventSponsorshipState;
  constructor(public formId: Number) {}
}

export class LoadEventSponsorshipStateSuccess implements Action {
  readonly type = EventSponsorshipActionTypes.LoadEventSponsorshipStateSuccess;
  constructor(public payload: IEventSponsorship ) {}
}

export class LoadEventSponsorshipStateFail implements Action {
  readonly type = EventSponsorshipActionTypes.LoadEventSponsorshipStateFail;
  constructor(public payload: any) {}
}

export class EventSponsorshipScreenErrorReset implements Action {
  readonly type = EventSponsorshipActionTypes.EventSponsorshipScreenErrorReset;
}

export class LoadInitialState implements Action {
  readonly type = EventSponsorshipActionTypes.LoadInitialState;
}

export type EventSponsorshipActions = 
  LoadEventSponsorshipState
  | LoadEventSponsorshipStateSuccess
  | LoadEventSponsorshipStateFail
  | EventSponsorshipScreenErrorReset
  | LoadInitialState;